import { Link, useLocation } from "react-router-dom";
import { Zap } from "lucide-react";

export const SiteHeader = ({ dark = false }) => {
  const loc = useLocation();
  return (
    <header
      className={`sticky top-0 z-50 border-b ${
        dark ? "bg-[#0A0A0A] border-[#262626] text-[#FAFAFA]" : "bg-[#FAFAFA] border-[#E5E5E5] text-[#0A0A0A]"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
          <span className="w-8 h-8 bg-volt flex items-center justify-center">
            <Zap className="w-5 h-5 text-black" strokeWidth={2.5} />
          </span>
          <span className="font-display font-black text-lg tracking-tighter">BESS BRIEF</span>
        </Link>
        <nav className="flex items-center gap-1 text-xs tracking-[0.15em] uppercase font-semibold">
          <Link to="/" className={`px-4 py-2 transition-colors hover:bg-black hover:text-white ${loc.pathname === "/" ? "underline" : ""}`} data-testid="nav-home">Subscribe</Link>
          <Link to="/read" className={`px-4 py-2 transition-colors hover:bg-black hover:text-white ${loc.pathname === "/read" ? "underline" : ""}`} data-testid="nav-read">Read Briefs</Link>
          <Link to="/admin" className="px-4 py-2 transition-colors hover:bg-volt hover:text-black border border-current ml-2" data-testid="nav-admin">Admin</Link>
        </nav>
      </div>
    </header>
  );
};
